import script from "./BillAdjustPreviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BillAdjustPreviewModal.vue?vue&type=script&setup=true&lang=js"

import "./BillAdjustPreviewModal.vue?vue&type=style&index=0&id=a881a636&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a881a636"]])

export default __exports__